export const widgetName = "property";